<template>
  <div class="logistics-request-detail bg-white rounded" v-loading="loading">
    <div class="detail-page-header">
      <h4 class="mb-0">Chi tiết yêu cầu</h4>
    </div>

    <div class="detail-page-body">
      <div class="row detail-grid">
        <div class="col-xl-6 col-lg-12 mb-4 mb-xl-0">
          <RequestInfo :requestInfo="requestDetail" />
        </div>

        <div class="col-xl-6 col-lg-12">
          <div class="detail-side-stack">
            <section class="detail-section-card action-section-card">
              <div class="section-header">
                <div>
                  <h5 class="section-title mb-1">Nhập kết quả xử lý</h5>
                  <p class="section-subtitle mb-0">
                    Cập nhật trạng thái và ghi chú xử lý cho yêu cầu này.
                  </p>
                </div>
              </div>

              <div v-if="!boxResult" class="action-entry-wrap">
                <div class="request-result-trigger">
                  <button
                    @click="handleOpenResult"
                    class="btn btn-outline-info font-weight-bold trigger-action-btn"
                  >
                    <i class="fas fa-pen mr-1"></i> Nhập kết quả
                  </button>
                </div>
              </div>

              <div v-else>
                <ResultProcessingComponent
                  :requestId="requestId"
                  @showBoxResult="boxResult = false"
                  @loadData="loadData"
                />
              </div>
            </section>

            <section class="detail-section-card history-section-card">
              <div class="section-header">
                <div>
                  <h5 class="section-title mb-1">Lịch sử xử lý</h5>
                </div>
              </div>
              <ProcessingHistory :historyList="processingHistory" />
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RequestInfo from "./components/RequestInfo.vue";
import ResultProcessingComponent from "./components/ResultProcessingComponent.vue";
import ProcessingHistory from "./components/ProcessingHistory.vue";
import { GET_LOGISTICS_REQUEST_DETAIL } from "@/core/services/store/logistics/logistics.module";

export default {
  name: "RequestDetail",
  components: {
    RequestInfo,
    ResultProcessingComponent,
    ProcessingHistory,
  },
  data() {
    return {
      loading: true,
      boxResult: false,
      requestDetail: {},
      processingHistory: [],
      requestId: null,
    };
  },
  computed: {
    isCompletedTicket() {
      return Number(this.requestDetail.logistic_ticket_status) === 4 || this.requestDetail.status === "Hoàn thành";
    },
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Logistics", route: "logisticsRequestList" },
      { title: "Chi tiết yêu cầu" },
    ]);
    this.requestId = this.$route.params.id;
    this.loadData();
  },
  methods: {
    handleOpenResult() {
      if (this.isCompletedTicket) {
        this.$message.warning("Ticket đã hoàn thành, không thể nhập kết quả");
        return;
      }
      this.boxResult = true;
    },
    loadData() {
      this.loading = true;
      this.$store.dispatch(GET_LOGISTICS_REQUEST_DETAIL, this.requestId)
        .then((res) => {
          if (!res.error) {
            this.requestDetail = res.data || {};
            this.processingHistory = res.processingHistory || [];
          }
        }).catch((e) => {
        console.log(e, "Error loading request detail");
        this.$notify.error({
          title: "Lỗi",
          message: "Không thể tải thông tin chi tiết yêu cầu",
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.logistics-request-detail {
  border: 1px solid #e8edf4;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.04);
}

.detail-page-header {
  padding: 24px 32px 18px;
  border-bottom: 1px solid #edf2f7;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
}

.detail-page-body {
  padding: 28px 32px 32px;
}

.detail-grid {
  align-items: stretch;
}

.detail-side-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-section-card {
  padding: 22px 24px;
  border: 1px solid #e8edf4;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.03);
}

.action-section-card {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}

.history-section-card {
  min-height: 340px;
}

.section-header {
  margin-bottom: 14px;
}

.section-title {
  color: #0f172a;
  font-size: 16px;
}

.section-subtitle {
  color: #64748b;
  font-size: 13px;
  line-height: 1.65;
}

.action-entry-wrap {
  padding-top: 2px;
}

.request-result-trigger {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #dbe7ff;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.trigger-action-btn {
  flex-shrink: 0;
  white-space: nowrap;
}

@media screen and (max-width: 767px) {
  .detail-page-header,
  .detail-page-body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .detail-section-card {
    padding: 18px 16px;
  }

  .request-result-trigger {
    flex-direction: column;
    align-items: flex-start;
  }

  .trigger-action-btn {
    width: 100%;
  }
}
</style>
